<template>
  <div class="navigation-container">
    <v-list class="pt-0 pb-0">
      <v-list-item-group>
        <router-link to="/">
          <v-list-item link v-bind:style="ProductActiveBorder($store.state.productsStatus)">
            <v-list-item-title class="navigation-title">
              PRODUCT CATEGORY <br>
              <small>{{selectedCategory}}</small>
            </v-list-item-title>
          </v-list-item>
        </router-link>

        <router-link :to="{ name: 'InstrumentType', params: { id: category_id }}"  :disabled="!$store.state.isInstrumentTypeEnabled" :event="$store.state.isInstrumentTypeEnabled ? 'click' : ''">
          <v-list-item  link  :disabled="!$store.state.isInstrumentTypeEnabled" v-bind:style="InstrumentActiveBorder($store.state.instrumentTypeStatus)">
            <v-list-item-title class="navigation-title">
             PRODUCT TYPE <br>
             <small>{{$store.state.selected_instrumentType}}</small>
            </v-list-item-title>
          </v-list-item>
        </router-link>
        
        <router-link  :to="{name:'Result', params:{ id: category_id , intrumentype_id:intrumentype_id}}" :disabled="!$store.state.isApproximateEnabled" :event="$store.state.isApproximateEnabled ? 'click' : ''">
          <v-list-item link :disabled="!$store.state.isApproximateEnabled" v-bind:style="ResultActiveBorder($store.state.approximateStatus)">
            <v-list-item-title class="navigation-title">
              ESTIMATED POWER MODULE LIFE RESULTS
            </v-list-item-title>
          </v-list-item>
        </router-link>
       </v-list-item-group >
     </v-list>
  </div>
</template>

<script>
import products from "../json/products.json"
export default {
  data: () => ({
    drawer: true,
    mini: true,
    default_dark:null,
  }),
  created(){
  },
  props:["category_id","intrumentype_id"],
  computed:{
    selectedCategory(){
      if(this.category_id != ""){
        var product_index = products.findIndex(x => x.id === this.category_id)
        this.$store.state.selected_productGroup = products[product_index].product_name 
        return products[product_index].product_name 
      }
      
    }
  },
  mounted(){
    
  },
  methods:{
    ProductActiveBorder(active){
      var border =""
      var color =""
      if(active == "done"){
        border = "15px solid #00AA7E",
        color="white"
      }else if(active == "incomplete"){
        color="#C0C0C0"
        border = "15px solid black"
      }
      return {
        borderLeft:border,
        backgroundColor:color
      };
    },
    InstrumentActiveBorder(active){
      var border =""
      var color =""
      var bg_color = ""
      if(active == "done"){
        border = "15px solid #00AA7E",
        bg_color="white"
      }else if(active == "incomplete"){
        bg_color="#C0C0C0";
        border = "15px solid black"
      }else if(active == "disable"){
        bg_color="white"
        border = "15px solid black"
      }
      return {
        borderLeft:border,
        backgroundColor:bg_color
      };
    },
    ResultActiveBorder(active){
      var border =""
      var bg_color = ""
      if(active == "done"){
        border = "15px solid #00AA7E",
        bg_color="white"
      }else if(active == "incomplete"){
        bg_color="#C0C0C0";
        border = "15px solid black"
      }else if(active == "disable"){
        bg_color="white"
        border = "15px solid black"
      }
      return {
        borderLeft:border,
        backgroundColor:bg_color
      };
    },
  }
};
</script>

<style scoped>
.v-application a {
  color: #0079c1;
  text-decoration: none;
}
.navigation-container{
  text-align: left;
  width: 365px;
  margin-right: 15px;
}
.navigation-container .v-list-item{
  height: 70px;
  border-left: 15px solid #999999;
  border-top: 0px solid #F0F0F0;
  border-right: 1px solid #F0F0F0;
  border-bottom:1px solid #F0F0F0;
}
.navigation-title{
  font-size: 12px;
  font-weight: 600;
}
.bg-active{
  border-left: 15px solid #00AA7E !important;
  
}
a .v-list-item--disabled{
   cursor:not-allowed!important;
}

</style>